export class User {
    public image: string = '/no-user.png';
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
}